import React, {useState, useContext, useEffect} from 'react';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import Preloader from '../components/Preloader/Preloader';
import { ProductContext } from '../ProductProvider';
import {Helmet} from 'react-helmet-async';

const config = require('../config.json');

const PRAYERS_DATA = [
    {
        name: 'Sign of the Cross',
        content: 'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        lang: 'Eng'
    },
    {
        name: 'Our Father (The Lord\'s Prayer)',
        content: 'Our Father, Who art in heaven, hallowed be Thy name; Thy kingdom come; Thy will be done on earth as it is in heaven. Give us this day our daily bread; and forgive us our trespasses as we forgive those who trespass against us; and lead us not into temptation, but deliver us from evil. Amen.',
        lang: 'Eng'
    },
    {
        name: 'Hail Mary',
        content: 'Hail Mary, full of grace, the Lord is with thee; blessed art thou amongst women, and blessed is the fruit of thy womb, Jesus. Holy Mary, Mother of God, pray for us sinners, now and at the hour of our death. Amen.',
        lang: 'Eng'
    },
    {
        name: 'Glory Be (Doxology)',
        content: 'Glory be to the Father, and to the Son, and to the Holy Spirit. As it was in the beginning, is now, and ever shall be, world without end. Amen.',
        lang: 'Eng'
    },
    {
        name: 'Apostles\' Creed',
        content: 'I believe in God, the Father almighty, Creator of heaven and earth, and in Jesus Christ, his only Son, our Lord, who was conceived by the Holy Spirit, born of the Virgin Mary, suffered under Pontius Pilate, was crucified, died and was buried; he descended into hell; on the third day he rose again from the dead; he ascended into heaven, and is seated at the right hand of God the Father almighty; from there he will come to judge the living and the dead. I believe in the Holy Spirit, the holy catholic Church, the communion of saints, the forgiveness of sins, the resurrection of the body, and life everlasting. Amen.',
        lang: 'Eng'
    },
    {
        name: 'Nicene Creed',
        content: 'I believe in one God, the Father almighty, maker of heaven and earth, of all things visible and invisible. I believe in one Lord Jesus Christ, the Only Begotten Son of God, born of the Father before all ages. God from God, Light from Light, true God from true God, begotten, not made, consubstantial with the Father; through him all things were made. For us men and for our salvation he came down from heaven, and by the Holy Spirit was incarnate of the Virgin Mary, and became man. For our sake he was crucified under Pontius Pilate, he suffered death and was buried, and rose again on the third day in accordance with the Scriptures. He ascended into heaven and is seated at the right hand of the Father. He will come again in glory to judge the living and the dead and his kingdom will have no end. I believe in the Holy Spirit, the Lord, the giver of life, who proceeds from the Father and the Son, who with the Father and the Son is adored and glorified, who has spoken through the prophets. I believe in one, holy, catholic and apostolic Church. I confess one Baptism for the forgiveness of sins and I look forward to the resurrection of the dead and the life of the world to come. Amen.',
        lang: 'Eng'
    },
    {
        name: 'சிலுவை அடையாளம்',
        content: 'தந்தை மகன் தூய ஆவியாரின் பெயராலே – ஆமென்',
        lang: 'Tam'
    },
    {
        name: 'நம்பிக்கை அறிக்கை',
        content: 'விண்ணகத்தையும் மண்ணகத்தையும் படைத்த எல்லாம் வல்ல தந்தையாகிய கடவுளை நம்புகிறேன். அவருடைய ஒரே மகனாகிய இயேசு கிறிஸ்துவை நம்புகிறேன். இவர் தூய ஆவியாரால் கருவுற்று தூய கன்னிமரியாவிடமிருந்து பிறந்தார். பொந்தியு பிலாத்தின் அதிகாரத்தில் பாடுபட்டு சிலுவையில் அறையப்பட்டு இறந்து அடக்கம் செய்யப்பட்டார். பாதாளத்தில் இறங்கி மூன்றாம் நாள் இறந்தோரிடமிருந்து உயிர்த்தெழுந்தார். விண்ணகம் சென்று எல்லாம் வல்ல தந்தையாகிய கடவுளின் வலப் பக்கத்தில் வீற்றிருக்கிறார். அவ்விடத்திலிருந்து வாழ்வோருக்கும் இறந்தோருக்கும் தீர்ப்பு வழங்க மீண்டும் வருவார். தூய ஆவியாரை நம்புகிறேன். தூய கத்தோலிக்க திருச்சபையையும் புனிதர்களுடைய சமூக உறவையும் நம்புகிறேன். பாவ மன்னிப்பை நம்புகிறேன். உடலின் உயிர்ப்பை நம்புகிறேன். நிலைவாழ்வை நம்புகிறேன்.– ஆமென்.',
        lang: 'Tam'
    },
    {
        name: 'இயேசு கற்றுத்தந்த இறைவேண்டல்',
        content: 'விண்ணுலகில் இருக்கிற எங்கள் தந்தையே உமது பெயர் தூயது எனப் போற்றப்பெறுக உமது ஆட்சி வருக உமது திருவுளம் விண்ணுலகில் நிறைவேறுவது போல மண்ணுலகிலும் நிறைவேறுக. எங்கள் அன்றாட உணவை இன்று எங்களுக்குத் தாரும். எங்களுக்கு எதிராகக் குற்றம் செய்வோரை நாங்கள் மன்னிப்பது போல எங்கள் குற்றங்களை மன்னியும். எங்களை சோதனைக்கு உட்படுத்தாதேயும் தீயோனிடமிருந்து எங்களை விடுவித்தருளும். ஆமென்.',
        lang: 'Tam'
    },
    {
        name: 'மங்கள வார்த்தை மன்றாட்டு',
        content: 'அருள் மிகப் பெற்ற மரியே வாழ்க ஆண்டவர் உம்முடனே பெண்களுக்குள் ஆசி பெற்றவர் நீரே உம்முடைய திருவயிற்றின் கனியாகிய இயேசுவும் ஆசிபெற்றவரே. தூய மரியே இறைவனின் தாயே பாவிகளாய் இருக்கிற எங்களுக்காக இப்பொழுதும் எங்கள் இறப்பின் வேளையிலும் வேண்டிக்கொள்ளும். ஆமென்.',
        lang: 'Tam'
    },
    {
        name: 'மூவொரு இறைவன் புகழ்',
        content: 'தந்தைக்கும் மகனுக்கும் தூய ஆவியாருக்கும் மாட்சிமை உண்டாகுக. தொடக்கத்தில் இருந்ததுபோல இப்பொழுதும் எப்பொழுதும் என்றென்றும் இருப்பதாக – ஆமென்.',
        lang: 'Tam'
    },
        
];
const ROSARY_PRAYERS_DATA = [
    {
        name: 'Sign of the Cross',
        content: 'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        lang: 'Eng'
    },
    {
        name: 'Our Father (The Lord\'s Prayer)',
        content: 'Our Father, Who art in heaven, hallowed be Thy name; Thy kingdom come; Thy will be done on earth as it is in heaven. Give us this day our daily bread; and forgive us our trespasses as we forgive those who trespass against us; and lead us not into temptation, but deliver us from evil. Amen.',
        lang: 'Eng'
    },
    {
        name: 'Hail Mary',
        content: 'Hail Mary, full of grace, the Lord is with thee; blessed art thou amongst women, and blessed is the fruit of thy womb, Jesus. Holy Mary, Mother of God, pray for us sinners, now and at the hour of our death. Amen.',
        lang: 'Eng'
    },
    {
        name: 'Glory Be (Doxology)',
        content: 'Glory be to the Father, and to the Son, and to the Holy Spirit. As it was in the beginning, is now, and ever shall be, world without end. Amen.',
        lang: 'Eng'
    },
    {
        name: 'Apostles\' Creed',
        content: 'I believe in God, the Father almighty, Creator of heaven and earth, and in Jesus Christ, his only Son, our Lord, who was conceived by the Holy Spirit, born of the Virgin Mary, suffered under Pontius Pilate, was crucified, died and was buried; he descended into hell; on the third day he rose again from the dead; he ascended into heaven, and is seated at the right hand of God the Father almighty; from there he will come to judge the living and the dead. I believe in the Holy Spirit, the holy catholic Church, the communion of saints, the forgiveness of sins, the resurrection of the body, and life everlasting. Amen.',
        lang: 'Eng'
    },
    {
        name: 'Nicene Creed',
        content: 'I believe in one God, the Father almighty, maker of heaven and earth, of all things visible and invisible. I believe in one Lord Jesus Christ, the Only Begotten Son of God, born of the Father before all ages. God from God, Light from Light, true God from true God, begotten, not made, consubstantial with the Father; through him all things were made. For us men and for our salvation he came down from heaven, and by the Holy Spirit was incarnate of the Virgin Mary, and became man. For our sake he was crucified under Pontius Pilate, he suffered death and was buried, and rose again on the third day in accordance with the Scriptures. He ascended into heaven and is seated at the right hand of the Father. He will come again in glory to judge the living and the dead and his kingdom will have no end. I believe in the Holy Spirit, the Lord, the giver of life, who proceeds from the Father and the Son, who with the Father and the Son is adored and glorified, who has spoken through the prophets. I believe in one, holy, catholic and apostolic Church. I confess one Baptism for the forgiveness of sins and I look forward to the resurrection of the dead and the life of the world to come. Amen.',
        lang: 'Eng'
    },
    {
        name: 'சிலுவை அடையாளம்',
        content: 'தந்தை மகன் தூய ஆவியாரின் பெயராலே – ஆமென்',
        lang: 'Tam'
    },
    {
        name: 'நம்பிக்கை அறிக்கை',
        content: 'விண்ணகத்தையும் மண்ணகத்தையும் படைத்த எல்லாம் வல்ல தந்தையாகிய கடவுளை நம்புகிறேன். அவருடைய ஒரே மகனாகிய இயேசு கிறிஸ்துவை நம்புகிறேன். இவர் தூய ஆவியாரால் கருவுற்று தூய கன்னிமரியாவிடமிருந்து பிறந்தார். பொந்தியு பிலாத்தின் அதிகாரத்தில் பாடுபட்டு சிலுவையில் அறையப்பட்டு இறந்து அடக்கம் செய்யப்பட்டார். பாதாளத்தில் இறங்கி மூன்றாம் நாள் இறந்தோரிடமிருந்து உயிர்த்தெழுந்தார். விண்ணகம் சென்று எல்லாம் வல்ல தந்தையாகிய கடவுளின் வலப் பக்கத்தில் வீற்றிருக்கிறார். அவ்விடத்திலிருந்து வாழ்வோருக்கும் இறந்தோருக்கும் தீர்ப்பு வழங்க மீண்டும் வருவார். தூய ஆவியாரை நம்புகிறேன். தூய கத்தோலிக்க திருச்சபையையும் புனிதர்களுடைய சமூக உறவையும் நம்புகிறேன். பாவ மன்னிப்பை நம்புகிறேன். உடலின் உயிர்ப்பை நம்புகிறேன். நிலைவாழ்வை நம்புகிறேன்.– ஆமென்.',
        lang: 'Tam'
    },
    {
        name: 'இயேசு கற்றுத்தந்த இறைவேண்டல்',
        content: 'விண்ணுலகில் இருக்கிற எங்கள் தந்தையே உமது பெயர் தூயது எனப் போற்றப்பெறுக உமது ஆட்சி வருக உமது திருவுளம் விண்ணுலகில் நிறைவேறுவது போல மண்ணுலகிலும் நிறைவேறுக. எங்கள் அன்றாட உணவை இன்று எங்களுக்குத் தாரும். எங்களுக்கு எதிராகக் குற்றம் செய்வோரை நாங்கள் மன்னிப்பது போல எங்கள் குற்றங்களை மன்னியும். எங்களை சோதனைக்கு உட்படுத்தாதேயும் தீயோனிடமிருந்து எங்களை விடுவித்தருளும். ஆமென்.',
        lang: 'Tam'
    },
    {
        name: 'மங்கள வார்த்தை மன்றாட்டு',
        content: 'அருள் மிகப் பெற்ற மரியே வாழ்க ஆண்டவர் உம்முடனே பெண்களுக்குள் ஆசி பெற்றவர் நீரே உம்முடைய திருவயிற்றின் கனியாகிய இயேசுவும் ஆசிபெற்றவரே. தூய மரியே இறைவனின் தாயே பாவிகளாய் இருக்கிற எங்களுக்காக இப்பொழுதும் எங்கள் இறப்பின் வேளையிலும் வேண்டிக்கொள்ளும். ஆமென்.',
        lang: 'Tam'
    },
    {
        name: 'மூவொரு இறைவன் புகழ்',
        content: 'தந்தைக்கும் மகனுக்கும் தூய ஆவியாருக்கும் மாட்சிமை உண்டாகுக. தொடக்கத்தில் இருந்ததுபோல இப்பொழுதும் எப்பொழுதும் என்றென்றும் இருப்பதாக – ஆமென்.',
        lang: 'Tam'
    },
        
];

export default function ContactUs() {
  const { loggedUser, generateDate, generateAccessionNo } = useContext(ProductContext);
  const [contactDetails, setContactDetails]= useState({username:"", emailID:"", phoneNumber:"", message:"" });
  const { enqueueSnackbar } = useSnackbar();
  const [loaded, setLoaded] = useState(true);

  useEffect(()=>{
    handleReset();
  },[])

  const handleSubmit=async(event)=>{
    event.preventDefault();
    try{
      const validationResult=validateFields();
      if(validationResult==="passed"){
        const todayDate=await generateDate();
        const taccessionNo=await generateAccessionNo();

        const {username, emailID, phoneNumber, message } = contactDetails;
        const params={
          clientID:loggedUser.website,
          msgID:"MSG"+taccessionNo,
          username:loggedUser.nickname,
          emailID:emailID,
          phoneNumber:phoneNumber,
          message:message,
          dateSubmitted:todayDate,
          msgStatus:"New",
          dateClosed:"NA",
          comments:"NA",
          fullname:loggedUser.name,
          updatedBy:loggedUser.nickname,
          updatedOn:todayDate
        };
        console.log("params : ", params);
        await axios.post(`${config.api.invokeURL}/vjlibrary/contactus`,params, {  
          headers: {
           // Authorization: idToken,
            //'x-api-key':config.api.key
          }
        }).then(async(response) => {
         //console.log("Response : ", response);
            enqueueSnackbar("Request submitted successfully - " + params.msgID,{variant:'success'});
            handleReset();
          setLoaded(true)
      }).catch((error)=>{
        //console.log("Error : ", error);
      enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
      setLoaded(true);
      window.scrollTo(0,0);
    })
      }
    }catch(error){
      enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
    }
  }

  const handleReset=()=>{
    setContactDetails({...contactDetails, 
      username:'',
      emailID:'', 
      phoneNumber:'',
      message:"" });
  }

  const validateFields=()=>{
    var returnValue="passed";
    const {username, emailID, phoneNumber, message } = contactDetails;
    if(username===""){
      enqueueSnackbar("Name is mandatory.",{variant : 'info'});
      returnValue="failed";
    }else if(emailID===""){
      enqueueSnackbar("emailID is mandatory.",{variant : 'info'});
      returnValue="failed";
    }else if(phoneNumber===""){
      enqueueSnackbar("Phone Number is mandatory.",{variant : 'info'});
      returnValue="failed";
    }else if(message===""){
      enqueueSnackbar("Message is mandatory!.",{variant : 'info'});
      returnValue="failed";
    }else {
  returnValue="passed";
  }
return returnValue;
}

  const contactUsStyles = `
    .contact_section-bg {
      background: linear-gradient(120deg, #e0f7fa 0%, #b3e6fc 100%);
      min-height: 100vh;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .contact_section-modern {
      background: #fff;
      border-radius: 22px;
      box-shadow: 0 4px 32px 0 rgba(6,53,71,0.10);
      padding: 2.5rem 2.2rem;
      margin: 2.5rem auto;
      max-width: 1100px;
    }
    .contact_section-modern .heading_container h2 {
      font-size: 2.2rem;
      font-weight: 900;
      color: #063547;
      margin-bottom: 1.2rem;
      letter-spacing: 1.1px;
      text-shadow: 0 2px 8px rgba(6,53,71,0.10);
    }
    .contact_section-modern form {
      margin-top: 1.2rem;
    }
    .contact_section-modern input[type="text"],
    .contact_section-modern input[type="email"],
    .contact_section-modern .message-box {
      width: 100%;
      padding: 0.75rem 1.1rem;
      margin-bottom: 1.1rem;
      border: 1.5px solid #b3e6fc;
      border-radius: 8px;
      font-size: 1.08rem;
      background: #f8fafb;
      color: #063547;
      transition: border 0.18s, box-shadow 0.18s;
      outline: none;
      box-shadow: 0 1px 4px 0 rgba(6,53,71,0.06);
    }
    .contact_section-modern input[type="text"]:focus,
    .contact_section-modern input[type="email"]:focus,
    .contact_section-modern .message-box:focus {
      border: 1.5px solid #7ee8fa;
      box-shadow: 0 2px 8px 0 rgba(6,53,71,0.10);
    }
    .contact_section-modern button.btn-box {
      display: inline-block;
      background: linear-gradient(90deg, #7ee8fa 60%, #063547 100%);
      color: #063547;
      font-weight: 700;
      font-size: 1.08rem;
      border: none;
      border-radius: 8px;
      padding: 0.65rem 1.7rem;
      box-shadow: 0 2px 8px 0 rgba(6,53,71,0.10);
      transition: background 0.18s, color 0.18s, transform 0.18s;
      margin-top: 0.2rem;
      letter-spacing: 0.5px;
      cursor: pointer;
    }
    .contact_section-modern button.btn-box:hover {
      background: linear-gradient(90deg, #063547 60%, #7ee8fa 100%);
      color: #fff;
      transform: scale(1.06);
    }
    .contact_section-modern .img-box img {
      border-radius: 18px;
      box-shadow: 0 2px 16px 0 rgba(6,53,71,0.13);
      max-width: 100%;
      height: auto;
      background: #f8fafb;
    }
    @media (max-width: 900px) {
      .contact_section-modern {
        padding: 1.2rem 0.5rem;
        border-radius: 12px;
      }
      .contact_section-modern .heading_container h2 {
        font-size: 1.3rem;
      }
      .contact_section-modern input[type="text"],
      .contact_section-modern input[type="email"],
      .contact_section-modern .message-box {
        font-size: 0.98rem;
        padding: 0.5rem 0.7rem;
      }
      .contact_section-modern .btn-box button {
        font-size: 0.97rem;
        padding: 0.5rem 1.1rem;
      }
      .contact_section-modern .row.align-items-center {
        flex-direction: column;
      }
      .contact_section-modern .col-md-6 {
        width: 100%;
        max-width: 100%;
        margin-bottom: 1.5rem;
      }
      .contact_section-modern .img-box {
        display: flex;
        justify-content: center;
        margin-bottom: 0.5rem;
      }
      .contact_section-modern .img-box img {
        max-width: 80vw;
        height: auto;
      }
    }
  `;
  return (
    <div className="contact_section-bg">
      <Helmet>
        <title>Home - Inigo Library - Arul Kadal - Chennai</title>
        <meta name="description" content="Inigo Library - Arul Kadal - Chennai" />
        <meta name="keywords" content="Inigo Library - Arul Kadal - Chennai" /> 
      </Helmet>
      <style>{contactUsStyles}</style>
      {!loaded && <Preloader show={loaded ? false : true} />}
      <section className="contact_section-modern">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="heading_container ">
                <h2>Contact Us</h2>
              </div>
              <form action="#">
                <div>
                  <input type="text" placeholder="Name" 
                    value={contactDetails.username}
                    onChange={event=>setContactDetails({...contactDetails, username:event.target.value})}/>
                </div>
                <div>
                  <input type="email" placeholder="Email" 
                    value={contactDetails.emailID}
                    onChange={event=>setContactDetails({...contactDetails, emailID:event.target.value})}/>
                </div>
                <div>
                  <input type="text" placeholder="Phone Number" 
                    value={contactDetails.phoneNumber}
                    onChange={event=>setContactDetails({...contactDetails, phoneNumber:event.target.value})}/>
                </div>
                <div>
                  <input type="text" className="message-box" placeholder="Message" 
                    value={contactDetails.message}
                    onChange={event=>setContactDetails({...contactDetails, message:event.target.value})}/>
                </div>
                <div >
                  <button className="btn-box" onClick={event=>handleSubmit(event)}>
                    SEND
                  </button>
                </div>
              </form>
            </div>
            <div className="col-md-6">
              <div className="img-box">
                <img src="images/contact-img.png" alt="Contact" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
